import { Routes } from '@angular/router';
import { CookieComponent, ImpressumComponent } from '@systems/base';
import { NotFoundComponent } from './features/errors/not-found/not-found.component';
import { AuthGuardService } from './core';
import { newBankingGuard } from './core/auth/new-banking.guard';
import { newConservationGuard } from './core/auth/new-conservation.guard';
import { newDocumentSignerGuard } from './core/auth/new-document-signer.guard';
import { newPostboxGuard } from './core/auth/new-postbox.guard';
import { SystemsPartnerGuardService } from './core/auth/systems-partner-guard.service';
import { GotoStartpageComponent } from './core/goto-startpage/goto-startpage.component';
import { MainComponent } from './shared/main/main.component';

export const APP_ROUTES: Routes = [
  {
    path: '',
    component: MainComponent,
    canActivateChild: [AuthGuardService],
    children: [
      {
        path: '',
        component: GotoStartpageComponent
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES)
      },
      {
        path: 'invoices',
        loadChildren: () => import('./features/invoices/invoices.routes').then(m => m.INVOICES_ROUTES),
        canActivate: [newPostboxGuard]
      },
      {
        path: 'archive',
        loadChildren: () => import('./features/archive/archive.routes').then(m => m.ARCHIVE_ROUTES),
        canActivate: [newConservationGuard]
      },
      {
        path: 'settings',
        loadChildren: () => import('./features/settings/settings.routes').then(m => m.SETTINGS_ROUTES)
      },
      {
        path: 'statistics',
        loadChildren: () => import('./features/statistics/statistics.routes').then(m => m.STATISTICS_ROUTES)
      },
      {
        path: 'banking',
        loadChildren: () => import('./features/banking/banking.routes').then(m => m.BANKING_ROUTES),
        canActivate: [newBankingGuard],
        data: {
          roles: ['SystemsAdmin', 'BANKING.READ']
        }
      },
      {
        path: 'document-signer',
        loadChildren: () => import('./features/document-signer/document-signer.routes').then(m => m.DOCUMENT_SIGNER_ROUTES),
        canActivate: [newDocumentSignerGuard],
        data: {
          userIsAGuest: true
        }
      },
      {
        path: 'impressum',
        component: ImpressumComponent,
        canActivate: [SystemsPartnerGuardService],
      },
      {
        path: 'cookie',
        component: CookieComponent
      },
      {
        path: '**',
        component: NotFoundComponent
      },
    ]
  }
];
